<template>
  <div class="row justify-content-center">
      <div class="col-12 col-md-4 col-lg-2 mb-3" v-for="item in itemsToRender" :key="item.id">
        <selection-item :item="item" v-on:selected="selected" :is-transparent="isTransparent"></selection-item>
    </div>
  </div>
</template>

<script>
  import SelectionItem from './SelectionItem';

  export default {
    name: 'SelectionComponent',
    components: { SelectionItem },
    props: ['items', 'isTransparent'],
    data() {
      return {
        itemsToRender: this.items.map(item => Object.assign({}, item)),
      };
    },
    methods: {
      selected(id) {
        this.itemsToRender = this.itemsToRender.map((item) => {
          if (id === item.id) {
            return Object.assign({}, item, { isSelected: true });
          }
          return Object.assign({}, item, { isSelected: false });
        });
        this.$emit('selected', id);
      },
    },
  };
</script>

<style scoped>

</style>
